var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessNotificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 42"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 13",
    cx: 12,
    cy: 14,
    r: 12,
    fill: "#009688"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.84133 16.4087L15.0689 11.1731C15.1838 11.0577 15.3127 11 15.4556 11C15.5984 11 15.7275 11.0575 15.8429 11.1725C15.9583 11.2875 16.016 11.4165 16.016 11.5595C16.016 11.7025 15.9583 11.8317 15.8429 11.9471L10.3061 17.4759C10.1693 17.6127 10.0109 17.6811 9.83092 17.6811C9.6509 17.6811 9.49252 17.6127 9.35577 17.4759L7.17308 15.3012C7.05769 15.1863 7 15.0575 7 14.9146C7 14.7717 7.0575 14.6426 7.1725 14.5272C7.2875 14.4119 7.41651 14.3542 7.55952 14.3542C7.70252 14.3542 7.83171 14.4119 7.94708 14.5272L9.84133 16.4087Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 3",
    cx: 24,
    cy: 2,
    r: 2,
    fill: "#009688",
    fillOpacity: 0.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessNotificationIcon);
export default __webpack_public_path__ + "static/media/successNotificationIcon.87a32db2ee6eccc3753944ed82c8bfa7.svg";
export { ForwardRef as ReactComponent };